import { Injectable, OnInit, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class HistoryService implements OnInit, OnDestroy {
    private history: string[] = [];
    subscriptionList: Subscription[] = [];

    constructor(private router: Router, private location: Location) {}

    ngOnInit(): void {
        this.startSaveHistory();
    }

    ngOnDestroy(): void {
        this.subscriptionList.forEach((sub) => sub.unsubscribe());
    }

    startSaveHistory(): void {
        const routerSub = this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.history.push(event.urlAfterRedirects);
            }
            this.subscriptionList.push(routerSub);
        });
    }

    getHistory(): string[] {
        return this.history;
    }

    getPreviousUrl(): string {
        if (this.history.length > 0) {
            return this.history[this.history.length - 2];
        }
        return '';
    }

    goBack(): void {
        this.history.pop();

        if (this.history.length > 0) {
            this.location.back();
        } else {
            this.router.navigate(['/']);
        }
    }
}
